/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent {}
